/*
 * @Author: lbh
 * @Date: 2022-03-08 12:01:59
 * @LastEditors: lbh
 * @LastEditTime: 2024-06-29 14:04:39
 * @Description: file content
 */
import { addSystemLogo } from "@/js/api/system/api";
import util from "./util";
import MobileDetect from "mobile-detect";
import setting from "../../../package.json";

let requestTime = 0;
const addSystemLogoFun = (errorType, errorContent) => {
  // * 限制上傳頻率, 5S內 只能上傳一次
  if (Date.now() - requestTime < 5000) return;
  requestTime = Date.now();
  let userinfo = util.userInfoFun.get();
  let token = util.getToken();
  var md = new MobileDetect(window.navigator.userAgent);
  try {
    addSystemLogo({
      errorType: errorType,
      platformType: 2,
      deviceModel: md.mobile(),
      systemVersion: md.os() + md.version(md.userAgent()),
      deviceType: md.os().toLocaleLowerCase() == "ios" ? 2 : 1,
      appVersion: setting.version,
      errorContent: errorContent,
      errorUserDetails: `${token}_${userinfo.id}`,
    }).then((res) => {});
  } catch (error) {
    console.log(error);
  }
};

const log = {
  // 異常日誌
  error(errorContent) {
    addSystemLogoFun(4, errorContent);
  },
  // 接口
  request() {},
  //支付
  pay(errorContent) {
    addSystemLogoFun(3, errorContent);
  },
};

export default log;
